import { CircularProgress, Grid } from '@material-ui/core';
import React from 'react';

const DashboardLoading = ({ size = 30, style = {} }) => {
  return (
    <Grid item xs={12} container alignItems="center" justify="center" style={style}>
      <CircularProgress size={size} />
    </Grid>
  );
};

export default DashboardLoading;
